import MonthView from '../MonthView';

const Header = ({
  account,
  month,
  handleNewDate,
  setAnimation,
  txnViewMode = "t-view",
  setTxnViewMode,
}) => {
  return (
    <div className="py-2 d-flex align-items-center flex-wrap px-2 shadow-sm border-bottom">
      <div className="col-7 col-md-8 col-lg-9 d-flex align-items-center ps-2" align="left">
        {account?.get("photo") ? (
          <img
            src={account.get("photo")}
            className="profile-img my-2"
            onError={(e) => {
              e.target.src = "https://placehold.co/100x100"; // Set the fallback image URL on error
            }} />
        ) : (
          <i className="bi bi-person-circle"
            style={{ fontSize: "25px" }} />
        )}

        <span className='fs-5 px-2'>{account ? account.get("name").substring(0, 30) : ""}</span>
        {setTxnViewMode && (
          <div className="btn-group btn-group-sm" role="group" aria-label="Transaction View Mode">
            <button
              type="button"
              className={`btn ${txnViewMode === "t-view" ? "btn-app" : "btn-outline-app"}`}
              onClick={() => setTxnViewMode("t-view")}
              title="T-View (2-column layout)"
            >
              <i className="bi bi-layout-split me-1 d-inline d-sm-none" />
              <span className="d-none d-sm-inline">Khata</span>
            </button>
            <button
              type="button"
              className={`btn ${txnViewMode === "table" ? "btn-app" : "btn-outline-app"}`}
              onClick={() => setTxnViewMode("table")}
              title="Statement Table View"
            >
              <i className="bi bi-table me-1 d-inline d-sm-none" />
              <span className="d-none d-sm-inline">Statement</span>
            </button>
          </div>
        )}
      </div>
      <div className="col-5 col-md-4 col-lg-3 pe-2 d-flex justify-content-end align-items-center gap-2" align="right">
        <MonthView
          selectedDate={month}
          handleNewDate={handleNewDate}
          setAnimation={setAnimation}
        />
      </div>
    </div>
  )
}

export default Header;